// 繁體中文語言包
export default {
	// 導航
	nav: {
		home: '首頁',
		about: '關於我們',
		strategy: '投資策略',
		riskCompliance: '風控合規',
		crossBorder: '全球視野',
		business: '軟件下載',
		contact: '聯絡我們',
		langSwitch: '简',
	},

	// 通用（Header/Footer共用）
	common: {
		companyShort: '奧盛資產',
		companyFull: '奧盛資產管理有限公司',
		quickLinks: '快速連結',
		contactTitle: '聯繫方式',
	},

	// 首頁 - Hero區域
	hero: {
		enTitle: 'A.C Asset Management Limited · 奧盛資產',
		tags: ['香港國際金融中心', '成立於2016', '專業投資者', '跨境資產配置'],
		subtitle: '多策略 · 風險優先',
		title: '跨市場 · 多策略 · 長期價值',
		description: '奧盛資產成立於2016年，立足香港國際金融中心，聚焦專業投資者資產配置需求，構建研究驅動、風險優先、多策略協同的資產管理體系，致力於在複雜市場環境中實現長期穩健回報。',
		ctaWhitepaper: '查看白皮書',
		ctaVideo: '觀看公司影片',
	},

	// 首頁 - 公司簡介
	intro: {
		enTitle: 'INSTITUTIONAL WEALTH',
		title: '立足香港，連接全球資本與中國市場',
		description: '奧盛資產依托香港國際金融市場優勢，結合系統化研究與資產配置能力，持續關注全球資本流動與中國市場機會，為專業投資者提供長期資產配置支持。',
		highlight1: '資產管理',
		highlight2: '證券投資',
		highlight3: '投資顧問',
		companyInfo: '公司圍繞**資產管理**、**證券投資**與**投資顧問**服務，強化流程透明、風險前置與適當性管理，在合規框架內完善專業服務體系。同時，奧盛資產打造盛維量研，聚焦量化研究、智能策略、數據分析與風險控制，承接內地市場的投研支持、技術協同、品牌運營與客戶服務職能，推動香港專業資源與內地市場需求有效銜接。',
		foundedDate: '2016.04.28',
		foundedLabel: '公司於香港註冊成立',
		companyNumber: 'BHS283',
		companyNumberLabel: '香港證監會中央編號',
		businessDirection: '跨境 · 多策略',
		businessDesc: '研究驅動與風險優先的業務取向',
		featureHkHub: '香港樞紐',
		featureHkHubDesc: '依托香港制度、法治與資本流動優勢，支撐跨境業務穩健開展。',
		featureResearch: '研究體系',
		featureResearchDesc: '覆蓋宏觀、資產類別與標的研究，形成多層級投研框架。',
		featureRiskFirst: '風控優先',
		featureRiskFirstDesc: '以風險管理機制為支撐，以全流程監控為保障，提升投資過程中的風險識別與管理能力。',
	},

	// 首頁 - 快速了解
	quickLinks: {
		title: '快速了解奧盛',
		subtitle: '了解奧盛資產的公司背景、投資方法、風控體系與全球視野，按需進入相關欄目。',
		about: {
			title: '關於我們',
			desc: '了解奧盛資產的發展歷程、公司理念與研究成果。',
		},
		strategy: {
			title: '投資策略',
			desc: '資產配置框架、多策略協同、研究驅動與執行複盤。',
		},
		riskCompliance: {
			title: '風控合規',
			desc: '投前、投中、投後風險管理與制度化合規治理。',
		},
		crossBorder: {
			title: '全球視野',
			desc: '',
		},
	},

	// 首頁 - 核心定位
	corePositioning: {
		enTitle: '',
		title: '核心定位',
		subtitle: '面向機構客戶與高淨值專業投資者，依托香港金融市場優勢，連接中國與國際資本市場，服務多市場資產布局。',
		item1Title: '基本面驅動',
		item1Desc: '立足中長期基本面研究，降低短期市場情緒干擾，提升投資決策與組合管理的一致性。',
		item2Title: '風控管理',
		item2Desc: '堅持風險前置，構建投前評估、投中監控、投後複盤的全流程風控閉環。',
		item3Title: '多資產多策略',
		item3Desc: '圍繞不同資產類別與多元投資策略進行組合管理，力求提升組合在不同市場週期下的穩定性。',
	},

	// 首頁 - 核心能力與服務
	coreServices: {
		enTitle: '',
		title: '核心能力與服務體系',
		subtitle: '依托香港成熟金融環境與市場基礎設施，奧盛資產以投研、投資與風控協同為核心，面向機構客戶及高淨值專業投資者，提供資產配置與投資顧問服務。',
		subtitleNote: '',
		service1Title: '合規穩健運營',
		service1Desc: '堅持在合規框架下穩健運營，持續完善投資管理流程與客戶服務體系。',
		service2Title: '全球資產布局',
		service2Desc: '依托香港國際金融中心優勢，連接中國與國際資本市場，動態調整組合結構，提升資產組合的穩健性與抗波動能力。',
		service3Title: '研究驅動投資',
		service3Desc: '基於持續研究與市場洞察，形成投資判斷，並透過穩健執行推動策略落地。',
		service4Title: '全流程風控',
		service4Desc: '覆蓋投前評估、投中監控與投後複盤，持續提升風險識別與應對能力。',
	},

	// 首頁 - 為什麼是香港
	whyHongKong: {
		enTitle: '',
		title: '為什麼是香港',
		subtitle: '香港具備成熟監管、法治環境與自由資本流動機制，是連接中國與國際資本市場的關鍵樞紐。',
		section1Title: '樞紐優勢與市場基礎',
		section1Desc: '依托香港國際金融樞紐優勢與成熟市場基礎設施，奧盛資產在規範市場環境下，持續完善研究、交易與合規流程，支撐長期、穩健、可複盤的資產配置實踐。',
		section2Title: '合規管理',
		section2Desc: '奧盛資產堅持合規運營，持續完善證券交易、資產管理與投資顧問服務的業務流程與管理機制。',
		section3Title: '市場連動',
		section3Desc: '依托香港金融市場優勢，持續關注中國與國際資本市場變化，提升跨市場研究與配置能力。',
		section4Title: '研究驅動',
		section4Desc: '以全球宏觀研究與中國市場洞察為基礎，支持多資產、多策略的長期配置實踐。',
	},

	// 首頁 - 業務體系概覽
	businessSystem: {
		enTitle: '01 · 業務體系',
		label: '業務體系',
		title: '業務體系概覽',
		subtitle: '奧盛資產圍繞**研究**、**投資**與**風控**三大環節，構建協同連動的業務體系。公司在制度約束下推進策略執行，將風險管理嵌入投資全流程，並透過相對獨立的監督機制保障業務穩健運行。',
		researchTitle: '市場研判',
		researchDesc: '跟踪宏觀與市場變化，形成動態判斷。',
		decisionTitle: '投資決策',
		decisionDesc: '結合研究判斷與風險約束，推動策略落地。',
		monitorTitle: '風險監控',
		monitorDesc: '動態跟踪組合風險，保障投資穩健運行。',
		ctaStrategy: '查看投資策略',
	},

	// 首頁 - 服務方向
	serviceDirection: {
		enTitle: '02 · 服務方向',
		label: '服務方向',
		title: '主要服務方向',
		subtitle: '公司聚焦資產管理、證券投資及投資顧問相關業務，依托系統化投研、資產配置與風險管理能力，為專業投資者提供多元化服務支持。',
		assetManagement: '資產管理',
		assetManagementDesc: '多資產配置，多策略協同。',
		securitiesInvestment: '證券投資',
		securitiesInvestmentDesc: '研究驅動投資，風控保障執行。',
		investmentAdvisory: '投資顧問',
		investmentAdvisoryDesc: '就證券提供意見',
		professionalClient: '客戶群體',
		professionalClientDesc: '機構客戶與專業投資者',
		professionalClientNote: '服務流程遵循適當性與披露要求。',
		fileDisclosure: '合規披露',
		fileDisclosureDesc: '以正式文件及適用條款為準。',
		ctaContact: '聯繫我們',
		ctaCrossBorder: '全球視野',
	},

	// 首頁 - 官網導覽
	siteNav: {
		title: '官網導覽',
		subtitle: '透過公司介紹、投資策略、風控合規等欄目，了解奧盛資產的專業優勢與服務體系。',
		about: {
			title: '關於我們',
			desc: '走進奧盛資產，了解公司背景、發展歷程與公司理念。',
		},
		strategy: {
			title: '投資策略',
			desc: '資產配置框架、多策略組合、研究驅動與執行機制。',
		},
		riskCompliance: {
			title: '風控合規',
			desc: '貫穿投資全過程的風險管理與合規保障。',
		},
	},

	// 首頁 - 理念關鍵詞
	philosophyKeywords: {
		enTitle: 'RESEARCH × PORTFOLIO × RISK',
		title: '研究驅動與執行協同',
		subtitle: '公司以研究框架為基礎，貫通組合構建與風控執行，推動策略從研究判斷到執行管理形成閉環。',
		signature: '透過定期複盤與動態調整組合結構，提升市場響應能力與組合韌性',
		keywords: ['研究驅動', '風險優先', '長期主義', '透明合規'],
		footerText: '奧盛資產堅持合規穩健展業，重視過程紀律與能力沉澱，持續服務專業投資者的長期價值目標。',
		sectionTitle: '我們的投資理念',
		sectionDesc: '奧盛資產堅持合規穩健展業，依托專業積累與系統化管理，持續服務機構與專業投資者的長期價值目標。',
		kw1: '研究驅動',
		kw2: '風險優先',
		kw3: '長期主義',
		kw4: '透明合規',
	},

	// 首頁 - 免責聲明
	disclaimer: {
		title: '合規先行 · 研究驅動 · 長期主義',
		desc: '本網站內容僅用於公司介紹與業務展示，不構成投資建議、產品推介或任何交易邀請。',
	},

	// 首頁 - 常用入口
	commonLinks: {
		title: '常用入口',
		subtitle: '白皮書、策略說明、聯絡渠道與常見問答，便於快速跳轉。',
		whitepaper: {
			title: '白皮書 PDF',
			desc: '在線閱讀（新視窗）與下載，了解跨境配置與多策略投資方法論。',
		},
		strategyMethod: {
			title: '投資方法與框架',
			desc: '資產配置、策略協同、執行複盤與迭代機制。',
		},
		contact: {
			title: '聯絡與接洽',
			desc: '公司註冊資訊、合規溝通說明與資料入口。',
		},
	},

	// 頁腳
	footer: {
		companyName: '奧盛資產管理有限公司',
		companyDesc: '立足香港 · 服務專業投資者的資產管理機構',
		disclaimer: '歡迎透過合規渠道了解公司服務與風險披露。本網站僅供展示，不構成任何投資建議、要約或要約邀請。',
		riskLink: '風控與合規',
		whitepaperLink: '白皮書 PDF',
		slogan: '合規先行 · 研究驅動 · 長期主義',
		copyright: '本網站僅供公司與業務展示，不構成任何投資建議、要約或要約邀請。投資有風險，決策請結合自身情況審慎評估。',
	},

	// 關於我們頁面
	about: {
		heroEnTitle: 'ABOUT US · 奧盛資產',
		heroTags: ['香港註冊', '成立於2016', '資產管理', '證券投資', '投資顧問'],
		heroSubtitle: '',
		heroTitle: '立足香港，連接中國與全球市場',
		heroDescription: '公司成立於2016年，持續圍繞資產管理、證券投資與投資顧問服務，構建覆蓋投研、投資與風控的系統化業務框架。',
		enJourney: 'ABOUT US · 奧盛資產管理有限公司',
		journeyTitle: '十餘年深耕，體系化投研與風控',
		journeySubtitle: '公司歷經十餘年發展，逐步形成覆蓋多市場、多策略的投研與資產配置能力，並持續強化治理結構、研究深度與全流程風險管理體系，為專業投資者長期價值目標提供支持。',
		layoutTag1: '全球視野',
		layoutTag1Desc: '連接中國與國際資本市場',
		layoutTag2: '多元配置',
		layoutTag2Desc: '覆蓋多類資產配置需求',
		layoutTag3: '投研驅動',
		layoutTag3Desc: '支撐多策略投資決策',
		enService: 'Company Vision',
		serviceTitle: '公司願景',
		serviceSubtitle: '以成為全球一流投資銀行為長期目標，持續提升跨境資本服務、全球資產配置與國際市場拓展能力，為客戶創造長期、穩健、可持續的價值。',
		serviceSignature: '',
		developmentTitle: '發展脈絡',
		developmentSubtitle: '奧盛資產在長期實踐中持續完善治理結構、研究深度與風險管理體系。',
		locationTag: '區位',
		locationDesc: '香港金融樞紐與法治基礎。',
		timeTag: '時間線',
		timeDesc: '2016 成立至今持續發展。',
		clientTag: '客戶',
		clientDesc: '面向專業投資者與機構。',
		hkPositionTitle: '香港區位與全球連接',
		hkPositionDesc: '依托香港國際金融中心優勢，連接中國與國際資本市場，持續強化全球視野能力，並以研究、投資與風控協同支撐長期穩健發展。',
		timeline2011: '公司於香港註冊成立，開啟資產管理業務布局。',
		timeline2016: '強化跨境配置能力，連接境內外市場機會。',
		timelineRecent: '持續強化多資產配置、多策略協同與全流程風險管理能力。',
		whitepaperTitle: '白皮書與影像資料',
		whitepaperSubtitle: '左側影片快速了解公司定位，右側白皮書查看完整方法論與業務脈絡。',
		videoTitle: '公司影片',
		videoDesc: '以下為奧盛資產宣傳影片，可直接在線播放。',
		paperTitle: '白皮書',
		paperDesc: '《全球視野下的跨境資產配置與多策略投資白皮書》在線閱覽與下載。為保證頁面閱讀體驗，白皮書不在頁面內直接展開。請透過以下方式在線閱讀或下載。',
		onlineRead: '在線閱讀（新視窗打開）',
		downloadPdf: '下載 PDF',
	},

	// 投資策略頁面
	strategy: {
		heroEnTitle: 'INVESTMENT STRATEGY · 投資策略',
		heroTags: ['資產配置', '多策略協同', '研究驅動', '紀律執行', '動態迭代'],
		heroSubtitle: '',
		heroTitle: '研究驅動的多策略投資體系',
		heroDescription: '奧盛資產以資產配置為核心，以風險管理為底層約束，在權益、固收及多元策略之間進行動態權重調整，追求組合長期穩定性。',
		enFramework: 'FRAMEWORK',
		frameworkTitle: '宏觀定向與深度研究',
		frameworkSubtitle: '公司結合宏觀週期、流動性環境與市場結構判斷，確定組合配置方向；同時透過行業比較與標的研究尋找超額收益來源，並依托執行跟踪和持續複盤機制，提升策略的長期適應性與有效性。',
		macroAnchor: '週期研判',
		macroAnchorDesc: '結合宏觀週期與流動性環境，明確組合配置方向。',
		midIndustry: '產業洞察',
		midIndustryDesc: '跟踪產業鏈變化與競爭格局，識別優質投資機會。',
		executionReview: '策略迭代',
		executionReviewDesc: '透過執行跟踪與持續複盤，保障策略長期有效。',
		enResearchPortfolio: 'FROM RESEARCH TO PORTFOLIO',
		rpTitle: '研究成果與組合轉化',
		rpDesc1: '將宏觀與行業判斷轉化為權重配置與標的選擇，並在風險預算、相關性約束下形成持倉結構。',
		rpDesc2: '透過策略執行與定期複盤，持續檢驗策略有效性，推動組合動態迭代。',
		sfTitle: '策略框架',
		sfDesc: '透過"宏觀判斷 - 行業研究 - 標的篩選 - 策略執行"的流程，將研究結論轉化為投資策略。',
		mappingTitle: '宏觀配置與風險約束',
		mappingDesc: '基於經濟週期與流動性判斷，轉化區域、行業與資產權重，並結合風險預算、相關性約束與集中度管理，提升組合穩健性。',
		mappingDesc2: '在組合管理中加入風險預算與相關性約束，降低策略集中風險。',
		mappingWeight: '權重轉化',
		mappingWeightDesc: '將宏觀結論轉化為區域與資產類別配置比例。',
		mappingBudget: '風險管理',
		mappingBudgetDesc: '基於相關性约束，控制組合集中度與回撤風險。',
		mappingStructure: '持倉框架',
		mappingStructureDesc: '構建可執行、可監控的持倉與限額管理體系。',
		allocLayerTitle: '區域資產配置',
		allocLayerItem1: '從經濟週期、政策路徑與流動性環境出發。',
		allocLayerItem2: '動態管理區域市場與資產類別權重。',
		allocLayerItem3: '在控制集中度與回撤風險的同時，提升組合配置效率。',
		stratLayerTitle: '多策略組合管理',
		stratLayerItem1: '以權益策略、固定收益策略及多策略協同為核心。',
		stratLayerItem2: '結合長期成長、估值匹配、信用質量與流動性管理。',
		stratLayerItem3: '多降低單一策略波動對整體組合的影響。',
		execTitle: '策略複盤',
		execSubtitle: '強調執行規範與持續複盤，透過績效評估不斷優化研究方法和執行路徑。',
		processExec: '策略執行',
		processExecDesc: '以制度與跟踪機制降低策略漂移與人為偏差，提升策略穩定性。',
		multiReview: '多維複盤',
		multiReviewDesc: '關注收益、波動、回撤與執行偏差，持續校準投資框架。',
		iterOptimize: '迭代優化',
		iterOptimizeDesc: '將複盤結論反饋至研究與執行環節，持續優化策略邏輯與流程機制。',
		researchFirst: '研究先行',
		researchFirstDesc: '投資前完成多層級研究評估，避免決策依賴短期情緒。',
		disciplineExec: '投研前置',
		disciplineExecDesc: '在投資決策前完成多層級研究評估，提升判斷的系統性與穩定性。',
		reviewOptimize: '策略落地',
		reviewOptimizeDesc: '透過流程化執行控制交易偏差，提升策略落地一致性。',
		bottomLine: '風險管理體系',
		bottomLineDesc: '圍繞風險識別、風險評估、敞口管理、回撤控制與合規監測，建立覆蓋投資決策、組合管理與執行複盤的全流程風險管理體系。',
	},

	// 風控合規頁面
	riskCompliance: {
		heroEnTitle: 'RISK & COMPLIANCE · 風控合規',
		heroTags: ['投前評估', '投中監控', '投後複盤', '職能獨立', '合規治理'],
		heroSubtitle: '',
		heroTitle: '風控與合規是資產管理的核心支撐',
		heroDescription: '公司將風險控制與合規管理作為資產管理體系的基礎能力，圍繞投前評估、投中監控與投後複盤建立全生命週期管理框架，並透過相對獨立的風控職能，保障投資決策與組合運行穩健有序。',
		enRiskCulture: 'RISK CULTURE',
		riskCultureTitle: '風險識別先於收益追求',
		riskCultureSubtitle: '對市場風險、流動性風險、信用風險、操作風險與合規風險進行分類管理，並透過制度約束與流程控制保障業務穩健運行。',
		classifiedMgmt: '風險管控',
		classifiedMgmtDesc: '識別、評估、監測與應對閉環。',
		processEmbed: '制度約束',
		processEmbedDesc: '權限、審批與留痕保障規範執行。',
		independentFunc: '流程控制',
		independentFuncDesc: '貫穿投前、投中、投後管理閉環。',
		loopTitle: '風險管理閉環',
		loopSubtitle: '系統識別市場、流動性、信用、操作與合規風險，構建分層管控與持續應對機制。',
		proactiveIdentify: '風險預判',
		proactiveIdentifyDesc: '投前評估情景變化與風險邊界。',
		dynamicTrack: '動態監控',
		dynamicTrackDesc: '投中監控敞口與偏離度。',
		closedLoopReview: '閉環複盤',
		closedLoopReviewDesc: '投後總結反饋，推動持續迭代。',
		fullProcessTitle: '全流程風險前置',
		fullProcessDesc1: '公司將風險控制嵌入投前評估、投中監控與投後複盤全流程。',
		fullProcessDesc2: '並透過相對獨立的風險管理機制，提升風險判斷的客觀性與組合運行的穩健性。',
		preInvest: '披露與管理',
		preInvestDesc: '資訊透明、客戶分類與文件留痕。',
		midMonitor: '培訓與文化',
		midMonitorDesc: '持續內訓，強化日常合規意識。',
		postReview: '審計與監督',
		postReviewDesc: '獨立檢視流程執行，推動持續改進。',
		complianceFocusTitle: '合規管理',
		complianceFocusSubtitle: '在適用監管要求下，持續完善內部制度、資訊披露與投資者風險匹配機制。',
		governanceTitle: '制度化治理體系',
		governanceDesc: '透過明確職責邊界、規範決策流程、持續培訓與內部審計，構建可持續的合規治理體系。',
		governanceDesc2: '公司以資訊透明、客戶風險匹配與服務規範為核心，持續提升服務質量與長期信任。',
		line1Title: '業務一線',
		line1Desc: '第一道防線',
		line2Title: '風險管理',
		line2Desc: '獨立監控',
		line3Title: '內審監督',
		line3Desc: '可追溯鏈條',
		disclosureTitle: '披露與適當性',
		disclosureDesc: '資訊透明、客戶分類與文件留痕。',
		trainingTitle: '培訓與文化',
		trainingDesc: '持續內訓與合規意識滲透日常。',
		auditTitle: '審計與監督',
		auditDesc: '第三道防線獨立檢視與改進。',
		threeLinesTitle: '三道防线治理機制',
		threeLinesDesc: '業務一線、風險管理與內部審計相互制衡，形成可審計、可追溯的治理鏈條。',
		threeLinesDesc2: '在適用法規框架下，將合規要求嵌入日常流程，推動制度執行形成閉環。',
		systemProcessTitle: '制度與流程',
		systemProcessItem1: '明確投資、風控與合規職責邊界。',
		systemProcessItem2: '重大投資決策實行規範審批與留痕管理。',
		systemProcessItem3: '內審監督定期檢查流程執行情況。',
		clientInfoTitle: '客戶與資訊管理',
		clientInfoItem1: '強化客戶分類、資訊披露與利益衝突管理。',
		clientInfoItem2: '建立溝通機制，保障資訊準確及時。',
		clientInfoItem3: '開展合規培訓，提升執行一致性。',
		bottomLine: '透明、審慎、可追溯',
		bottomLineDesc: '以資訊披露、客戶風險匹配與內控監督為核心，推動合規管理融入業務流程與長期經營體系。',
	},

	// 跨境配置頁面
	crossBorder: {
		heroEnTitle: 'CROSS-BORDER ALLOCATION · 全球視野',
		heroTags: ['全球宏觀', '中國深度', '香港樞紐', '分散化', '動態再平衡'],
		heroTitle: '全球資產視野',
		heroDescription: '奧盛資產依托香港國際金融市場優勢，持續關注中國內地與國際資本市場變化，結合全球資產視角與中國市場洞察，穩健開展跨市場資產布局。同時積極拓展中國內地市場，完善投研支持、品牌運營與客戶服務體系，推動香港專業資源與內地市場需求有效銜接，助力提升組合應對市場波動的能力。',
		enGlobalAlloc: 'GLOBAL ALLOCATION',
		globalAllocTitle: '全球布局',
		globalAllocSubtitle: '奧盛資產依托香港國際金融市場優勢，以全球資產視角連接中國內地與國際市場，推動香港專業資源與內地市場需求深度銜接，持續完善中國內地本地化服務體系。',
		globalView: '持牌機構',
		globalViewDesc: '依托香港專業資質，夯實合規運營基礎。',
		dynamicRebal: '香港樞紐',
		dynamicRebalDesc: '連接內地與國際市場，整合跨市場資源。',
		hkHub: '內地拓展',
		hkHubDesc: '完善本地服務體系，提升市場響應能力。',
		enHkHub: 'HONG KONG AS HUB',
		hkHubTitle: '香港優勢與全球視野',
		hkHubSubtitle1: '依托香港成熟金融環境，奧盛資產持續關注全球資本市場變化，結合全球宏觀判斷與中國市場洞察，適時調整組合結構，提升資產配置的穩健性與適應能力。',
		hkHubSubtitle2: '透過組合調整與風險管理機制，應對市場波動與環境變化，力求增強組合韌性。',
		logicLabel: '盛維量研',
		logicSubtitle: '盛維量研是奧盛資產面向量化研究與智能策略服務打造的專業平台，也是奧盛資產拓展中國內地市場的重要業務承接載體。',
		crossMarketTitle: '全球資產視野',
		crossMarketDesc1: '奧盛資產依托香港專業金融資源與跨市場視野，為盛維量研提供市場基礎、專業支持與資源協同；盛維量研則圍繞策略研究、數據分析、技術服務與客戶支持，推動相關能力在內地市場落地。',
		crossMarketDesc2: '透過盛維量研，奧盛資產將香港金融服務優勢、量化投研能力與內地本地化運營體系相結合，進一步提升對中國內地市場的服務深度與響應效率。',
		diversification: '戰略承接',
		diversificationDesc: '承接奧盛資產內地業務延伸，打造量化研究與智能策略服務平台。',
		cycleMisalign: '資源協同',
		cycleMisalignDesc: '依托香港金融資源，支持盛維量研開展策略研究與資產配置服務。',
		resilience: '本地落地',
		resilienceDesc: '聚焦技術協同、投研內容與客戶服務，提升內地市場服務能力。',
		globalAssetViewTitle: '奧盛資產',
		globalAssetViewItem1: '依托香港專業金融機構背景與國際市場資源。',
		globalAssetViewItem2: '發揮香港樞紐優勢，連接內地與國際市場。',
		globalAssetViewItem3: '提供專業支持、資源協同與穩健發展基礎。',
		chinaDeepTitle: '盛維量研',
		chinaDeepItem1: '聚焦量化研究、智能策略與資產配置服務。',
		chinaDeepItem2: '圍繞數據分析、策略研究與風險控制建設體系。',
		chinaDeepItem3: '承接內地運營、技術協同與客戶服務支持。',
		crossRiskTitle: '全球市場風控',
		crossRiskSubtitle: '跟踪內地與國際市場變化，結合研究分析與組合調整，提升跨市場配置穩定性。',
		crossRiskMainDesc: '奧盛資產持續關注全球市場政策變化、匯率波動、利率環境與資產價格變化，結合多市場數據跟踪與風險敞口管理，建立動態化風險識別與應對機制，提升跨市場資產配置的穩定性與長期適應能力。',
		crossRiskCardTitle: '全球風險管理',
		crossRiskSignature: '',
		policyRisk: '政策風險監測',
		policyRiskDesc: '持續關注不同市場的監管政策、宏觀環境與資金流向變化，提前識別潛在影響因素。',
		exchangeRateRisk: '匯率波動管理',
		exchangeRateRiskDesc: '跟踪主要貨幣匯率變化，結合跨市場資產配置需求，動態評估匯率波動帶來的影響。',
		marketDiff: '市場風險控制',
		marketDiffDesc: '圍繞資產價格波動、市場結構差異與風險敞口變化，建立動態調整機制，提升組合穩定性。',
		bottomLine: '發展願景',
		bottomLineDesc: '立足香港，連接中國內地與國際市場，推動專業金融資源、量化研究能力與本地化服務體系融合，打造穩健、專業、可持續發展的智能策略服務平台。',
	},

	// 聯絡我們頁面
	contact: {
		heroEnTitle: 'CONTACT US · 聯絡我們',
		heroTags: ['專業服務', '合規溝通', '長期合作'],
		heroTitle: '聯絡我們',
		heroDescription: '如需業務諮詢或合作溝通，歡迎聯繫我們，我們將及時回應。',
		enContactInfo: 'GET IN TOUCH',
		infoTitle: '期待與您長期互信、穩健同行',
		infoDesc: '正式接洽前，建議您充分了解公司資料、服務範圍及相關規範；具體產品條款、權責安排與風險揭示，均以正式法律文件為準。',
		channelLabel: '合規溝通',
		channelDesc: '諮詢與合作均透過官方渠道對接。',
		materialLabel: '資料了解',
		materialDesc: '了解公司資料與相關規範，便於後續溝通。',
		locationLabel: '香港主體',
		locationDesc: '註冊於香港，遵循適用監管與資訊披露要求。',
		enOfficeInfo: 'COMPLIANT COMMUNICATION',
		officeTitle: '以合規為前提的溝通',
		officeDesc1: '重視長期合作關係，業務溝通均在適用法規與客戶匹配要求下進行。 ',
		officeDesc2: '建議先了解公司資料與相關規範，再透過官方渠道接洽。 ',
		complianceLabel: '客戶匹配',
		complianceDesc: '面向專業投資者與合作機構。 ',
		infoLabel: '資訊準確',
		infoDesc2: '以正式文件與官網公告為準。 ',
		responseLabel: '及時回應',
		responseDesc: '業務諮詢將在工作日內處理。',
		companyInfoTitle: '公司資訊',
		companyName: '公司名稱：奧盛資產管理有限公司',
		companyNameEn: '英文名稱：A.C Asset Management Limited',
		companyDate: '成立時間：2016 年 04 月 28 日',
		companyRegNo: '',
		companyBizNo: '香港證監會中央編號：BHS283',
		companyLocation: '註冊地：香港',
		disclaimerTitle: '聯絡我們',
		disclaimerDesc: '如需了解更多服務資訊，歡迎與我們聯繫。',
		disclaimerItem1: '客戶服務：shengweiliangyan@gmail.com',
		disclaimerItem2: '投訴建議：acasset1215@gmail.com',
		disclaimerItem3: '公司地址：香港金鐘夏愨道18號海富中心一座10樓1002C室',
	},

	// 業務介紹
	business: {
		heroEnTitle: 'SOFTWARE DOWNLOAD · 軟件下載',
		heroTitle: '軟件下載',
		heroDescription: '為專業投資者提供多終端、多平台的交易與資訊服務支持。',
		platformTitle: '為用戶提供更好、更專業的軟件服務平台',
		platformDesc: '盛維量研是香港奧盛資產管理有限公司聯合多家技術與研究服務機構共同打造的量化研究與智能策略服務平台，圍繞數據分析、策略研究、資產配置與風險控制，構建系統化、可持續的投研服務體系。',
		appClientTitle: '奧盛資產APP客戶端',
		methodIosLabel: '蘋果',
		iosSearchHint: '（搜索：盛维量研plus）',
		methodAndroidLabel: '安卓',
		androidSearchHint: '（搜索：盛维量研）',
		pcClientTitle: '奧盛資產PC客戶端',
		pcClientDesc: '請使用電腦瀏覽器打開官網下載應用程式',
	},
}